import { FormResponseError } from './form-response-error';

export class FormResponse {
    public result: boolean;
    public data: object;
    public errors: Array<FormResponseError>;

    constructor(response: object) {
        this.result = response['type'] === 'success';

        this.data = response['params'];

        if (response['params']['errors'] !== undefined && response['params']['errors'] !== null) {

            this.errors = new Array<FormResponseError>();

            (response['params']['errors']).forEach(element => {
                this.errors.push(element);
            });
        }


    }
}